import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

function CloudSMabout() {
  return (
    <section className="cloud-sm-about p-100">
      <Container>
        <Row className="align-items-center">
          <Col xs={12} md={12} lg={6} xl={6} xxl={6}>
            <div className="image text-center mb-lg-0 mb-4">
              <StaticImage
                src="../../images/cloud-support-and-maintenance-services/cloudSMabout.webp"
                alt="Ari Marinovsky"
                className="img-fluid"
                layout="constrained"
                placeholder="blurred"
                formats={["auto"]}
                width={739}
                height={700}
              />
            </div>
          </Col>
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="ps-lg-0">
            <div className="content">
              <h2>Why Are Global Organizations Adapting Cloud? </h2>
              <p>
                Modern, forward-thinking businesses are outpacing change by
                investing in the cloud – they are engineering cloud-based
                infrastructures today for a secure, high-performing tomorrow.
                TekRevol’s independent research suggests that:
              </p>
              <ul className="pri-list">
                <li>
                  80% of cloud-first organizations have deployed hyperscalers:
                  Microsoft Azure, Google Cloud, and Amazon Web Services.
                </li>
                <li>
                  Approximately 86% of companies reported an increase in their
                  cloud initiatives over two years.
                </li>
                <li>
                  Companies are spending an average of 57% of their IT budgets
                  on cloud maintenance than new innovation initiatives.
                </li>
              </ul>
              <p>But most importantly, </p>
              <ul className="pri-list">
                <li>
                  And 82% of companies deploying cloud are using managed
                  services to a moderate or great degree for cloud support.
                </li>
                <li>
                  Organizations have saved more than 35% on operational costs
                  with the adoption and maintenance of the cloud.
                </li>
              </ul>
              <p>
                And if you’ve already embarked on the journey and planning to
                make it work for you – for unforeseen future, TekRevol can be
                your partner in change, sustainability and scaling.
              </p>
              <p>Let’s discuss cloud use cases for your organization.</p>
              <Link
                to="/contact"
                aria-label="Why Are Global Organizations Adapting Cloud?"
                className="btn-pri"
              >
                Book a call
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default CloudSMabout;
